/*
 * File: input-select.ts
 * File Created: 2023-12-22 09:45:44
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-05 10:57:23
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";

import vSelect from "vue-select";
import { PropInnateSync } from "@root/core/vue-props";
import { BaseInputComponent } from "../core/lib/base-input-component";

export interface IInputSelectData {
    "pre-i18n-key"?: string;
}
const defaultData: IInputSelectData = {};

@Component({
    components: { vSelect },
})
export default class InputSelect extends BaseInputComponent {
    @PropInnateSync("value", { type: [String, Number, Array], default: null })
    innateValue!: string | number | string[] | number[] | null;

    /// name / value pair of the select / options
    @Prop({ type: Object, default: () => ({}) })
    options!: any;

    @Prop({ type: Boolean, default: true })
    clearable!: boolean;

    @Prop({ type: Boolean })
    searchable?: boolean;

    @Prop({ type: Object, required: false })
    declare data: IInputSelectData;
    get mergedData() {
        return {
            ...defaultData,
            ...this.data,
        };
    }

    /// lifecycle hooks
    private mounted() {
        /// set clearable default value
        if (this.clearable == null) {
            this.clearable = this.multiple == true ? true : false;
        }
        /// set searchable default value
        if (this.searchable == null) {
            this.searchable = this.multiple == true ? true : false;
        }
    }

    /// private helpers
    get generatedOptions() {
        const pre = this.mergedData["pre-i18n-key"] ?? "";
        return Object.keys(this.options).map((value) => {
            // return {
            //     key: key == null ? this.$_(name) : this.$_(`${key}${name}`),
            //     value: this.options[name],
            // };
            let name = this.$_(`${pre}${this.options[value]}`);
            return {
                key: name,
                value,
            };
        });
    }

    // customize the layout of deselect
    get Deselect() {
        return {
            render: (h) =>
                h("iv-icon", {
                    props: {
                        icon: "fa-solid fa-xmark",
                    },
                }),
        };
    }

    calculatePosition(
        dropdown: HTMLElement,
        component: any,
        { width }: { width: string },
    ) {
        const toggle = component?.$refs?.toggle as HTMLElement | undefined;
        if (!toggle) return;

        const rect = toggle.getBoundingClientRect();
        const scrollX = window.scrollX || window.pageXOffset;
        const scrollY = window.scrollY || window.pageYOffset;
        const viewportHeight = window.innerHeight || 0;
        const margin = 8;

        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;

        let maxHeight = Math.max(120, spaceBelow - margin);
        dropdown.style.left = `${scrollX + rect.left}px`;
        dropdown.style.width = width;

        if (spaceBelow < 220 && spaceAbove > spaceBelow) {
            maxHeight = Math.max(120, spaceAbove - margin);
            dropdown.style.top = "auto";
            dropdown.style.bottom = `${viewportHeight - rect.top + margin}px`;
        } else {
            dropdown.style.bottom = "auto";
            dropdown.style.top = `${scrollY + rect.bottom + margin}px`;
        }

        dropdown.style.maxHeight = `${maxHeight}px`;
        dropdown.style.overflowY = "auto";

        return () => {
            dropdown.style.top = "";
            dropdown.style.bottom = "";
            dropdown.style.left = "";
            dropdown.style.width = "";
            dropdown.style.maxHeight = "";
            dropdown.style.overflowY = "";
        };
    }
}
